.footer {
  margin-top: auto;
  padding: clamp(40px, 6vw, 72px) 0 clamp(32px, 4vw, 48px);
  border-top: 1px solid var(--border);
  background: color-mix(in srgb, var(--bg) 92%, transparent);
}

.inner {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-8);
  align-items: start;
}

@media (min-width: 820px) {
  .inner {
    grid-template-columns: 1fr 1fr;
    gap: var(--space-9);
  }
}

/* ---------- Brand column (left) ---------- */

.brandCol {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-size: clamp(22px, 2.4vw, 28px);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: var(--text);
  font-family: var(--font-sans);
  width: max-content;
}

.brand:hover {
  color: var(--text);
}

.mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  flex-shrink: 0;
}

.brandName {
  display: inline-block;
}

.tag {
  font-size: 14px;
  color: var(--text-muted);
  margin: 0;
  max-width: 40ch;
}

.copy {
  font-size: 13px;
  color: var(--text-subtle);
  margin: 0;
}

/* ---------- Theme switcher ---------- */

.themeSwitcher {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  margin-top: var(--space-4);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-pill);
  width: max-content;
}

.themeBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  color: var(--text-subtle);
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  transition: color var(--dur-base) var(--ease-out),
    background var(--dur-base) var(--ease-out);
}

.themeBtn:hover {
  color: var(--text);
}

.themeBtn[data-active='true'] {
  background: var(--bg-elevated);
  color: var(--text);
  box-shadow: inset 0 0 0 1px var(--border-strong);
}

.themeBtn:focus-visible {
  outline: none;
  box-shadow: var(--ring);
}

/* ---------- Links (right) ---------- */

.linksGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-6);
}

@media (min-width: 820px) {
  .linksGrid {
    gap: var(--space-8);
    justify-content: end;
  }
}

.column {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}

.columnTitle {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text);
  margin: 0 0 var(--space-1);
}

.columnList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.columnLink {
  display: inline-block;
  font-size: 14px;
  color: var(--text-muted);
  transition: color var(--dur-base) var(--ease-out);
}

.columnLink:hover,
.columnLink:focus-visible {
  color: var(--text);
  outline: none;
}

@media (max-width: 560px) {
  .linksGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-6) var(--space-5);
  }
}
